const state = {
  isCollapse: false,
  listKeepAlive: {
    isReset: true,
    isInitPageNo: true,
    isQueryList: true,
    isQuerySelect: true
  },
  noticeLength: 0,
  kangmeiData: null,
  yaocaitongData: null,
  tiantiData: null,
  kangmeiLoading:false,
  yaocaitongLoading:false,
  tiantiLoading:false,
}

const mutations = {
  changeCollapse: (state, value) => {
    state.isCollapse = value
  },
  changeListKeepAlive: (state, value) => {
    state.listKeepAlive.isReset = value.isReset
    state.listKeepAlive.isInitPageNo = value.isInitPageNo
    state.listKeepAlive.isQueryList = value.isQueryList
    state.listKeepAlive.isQuerySelect = value.isQuerySelect
  },
  changeNoticeLength: (state, value) => {
    state.noticeLength = Number(value)
  },
  setkangmeiData(state, value) {
    state.kangmeiData = value
  },
  setyaocaitongData(state, value) {
    state.yaocaitongData = value
  },
  settiantiData(state, value) {
    state.tiantiData = value
  },
  clearAll(state) {
    state.kangmeiData = null;
    state.yaocaitongData = null;
    state.tiantiData = null;
  },
  setkangmeiLoadingState(state, value){
    state.kangmeiLoading=value;
  },
  settiandiLoadingState(state, value){
    state.tiantiLoading=value;
  },
  setyaocaitongLoadingState(state, value){
    state.yaocaitongLoading=value;
  },
}

const actions = {}

export default {
  state,
  mutations,
  actions
}